import React from 'react';
import PageWrapper from './style';
import PageTitle from '../../components/common/PageTitle';
import { connect } from 'react-redux';
import NotificationTable from '../../components/pushnotification/NotificationTable';

const Notification = (props) => {
	return (
		<PageWrapper {...props}>
			<PageTitle title="sidebar.notification" className="plr-15" />
			<div className="user-tbl">
				<NotificationTable {...props} />
			</div>
		</PageWrapper>
	);
};

const mapStateToProps = (state) => {
	return {
		...state.themeChanger,
	};
};

export default connect(mapStateToProps, null)(Notification);
